<template>
  <div id="app" class="app-root">
			<router-view/>
  </div>
</template>

<script>
	export default {
	  name: 'App',
    mounted() {
      var token = '';
      var raw = localStorage.getItem('token');
      if (raw) {
        try {
          var data = JSON.parse(raw);
          if (data && data.data && data.data.obj && data.data.obj.token) {
            token = data.data.obj.token;
          }
        } catch (e) {
          localStorage.removeItem('token');
        }
      }
      if (token && this.$route.path == '/') {
        window.location.href = '#/shop';
      }
    }
	}
</script>

<style>
.app-root {
	width: 100%;
	min-height: 100vh;
	overflow-x: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue